import API from './API.ts'

export default {
  getAll () {
    return API.httpClient.get('discount-presets')
  },
  save (preset) {
    return preset.id
      ? API.httpClient.post('discount-presets/update', { discount_preset_id: preset.id, name: preset.name, percent: Number(preset.percent) })
      : API.httpClient.post('discount-presets', { name: preset.name, percent: Number(preset.percent) })
  },
  remove (id) {
    return API.httpClient.post('discount-presets/delete', { discount_preset_id: id })
  }
}
